import React from "react";
import styles from "./chat-container.module.css";


const ChatContainer = (props) => {
  return (
    <div className={styles.container}>
      {props.children}
    </div>
  );
};

export { ChatContainer };
